import { RootState } from "@/redux/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IHotelRoomList } from "@/feature/hotel/checkout/types/hotel-room-list.type";
import { HotelRoomFilterState } from "@/feature/hotel/checkout/components/steps/hotel-rooms/hotel-room-list.types";

interface HotelRoomState {
  filterType: string;
  roomFilters: HotelRoomFilterState;
  roomList: IHotelRoomList[];
  searchRoom: string;
  showAll: boolean;
}

const initialState: HotelRoomState = {
  filterType: "",
  roomFilters: {
    boarding: [],
    type: [],
    status: [],
  },
  roomList: [],
  searchRoom: "",
  showAll: false,
};

const hotelRoomSlice = createSlice({
  name: "hotel_room_slice",
  initialState,
  reducers: {
    clearHotelRoomFilters: (state) => {
      state.filterType = "";
      state.searchRoom = "";
      state.showAll = false;
      state.roomFilters = {
        boarding: [],
        type: [],
        status: [],
      };
    },
    resetHotelRoomState: () => initialState,
    setHotelRoomFilterType: (state, action: PayloadAction<string>) => {
      state.filterType = action.payload;
    },
    setHotelRoomInventory: (
      state,
      action: PayloadAction<{
        roomList: IHotelRoomList[];
      }>,
    ) => {
      state.roomList = action.payload.roomList;
    },
    setHotelRoomSearch: (state, action: PayloadAction<string>) => {
      state.searchRoom = action.payload;
    },
    setHotelRoomShowAll: (state, action: PayloadAction<boolean>) => {
      state.showAll = action.payload;
    },
    setHotelRoomStatusFilters: (
      state,
      action: PayloadAction<HotelRoomFilterState["status"]>,
    ) => {
      state.roomFilters.status = action.payload;
    },
    toggleHotelRoomBoardingFilter: (state, action: PayloadAction<string>) => {
      const boarding = action.payload;
      state.roomFilters.boarding = state.roomFilters.boarding.includes(boarding)
        ? state.roomFilters.boarding.filter((item) => item !== boarding)
        : [...state.roomFilters.boarding, boarding];
    },
    toggleHotelRoomTypeFilter: (state, action: PayloadAction<string>) => {
      const type = action.payload;
      state.roomFilters.type = state.roomFilters.type.includes(type)
        ? state.roomFilters.type.filter((item) => item !== type)
        : [...state.roomFilters.type, type];
    },
  },
});

export const {
  clearHotelRoomFilters,
  resetHotelRoomState,
  setHotelRoomFilterType,
  setHotelRoomInventory,
  setHotelRoomSearch,
  setHotelRoomShowAll,
  setHotelRoomStatusFilters,
  toggleHotelRoomBoardingFilter,
  toggleHotelRoomTypeFilter,
} = hotelRoomSlice.actions;

export const useHotelRoomState = (state: RootState) => state.hotelRoomData;

export default hotelRoomSlice;
